import React, { useEffect, useState, type FC } from "react";
import classes from "./BrowseMenu.module.css";
import { motion, useAnimationControls } from "framer-motion";
import { useNavigate } from "react-router-dom";

type BrowseMenuProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const BrowseMenu: FC<BrowseMenuProps> = ({ open, setOpen }) => {
  const controls = useAnimationControls();

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "flex",
    },
  };

  useEffect(() => {
    if (open) {
      controls.start("visible");
      //   document.body.style.overflow = "hidden";
    }
    // return () => {
    //   document.body.style.overflow = "auto";
    // };
  }, [open]);

  const [menuItems, setMenuItems] = useState<
    { id: number; name: string; link: string; img: string }[]
  >([
    {
      id: 1,
      name: "Movies",
      link: "/movies",
      img: "/assets/navbar-icons/popcorn-active.png",
    },
    {
      id: 2,
      name: "Series",
      link: "/series",
      img: "/assets/navbar-icons/television-active.png",
    },
    {
      id: 3,
      name: "Shortz",
      link: "/shortz",
      img: "/assets/navbar-icons/clapper-active.png",
    },
    {
      id: 4,
      name: "Community",
      link: "/community",
      img: "/assets/navbar-icons/community-active.png",
    },
  ]);

  const handleClose = () => {
    controls.start("hidden");
    setOpen(false);
  };

  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    controls.start("hidden");
    setOpen(false);
    navigate(path, {
      state: {
        reset: true,
      },
    });
  };

  return (
    <motion.div
      className={classes.browse_menu_container}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        ease: "linear",
      }}
    >
      <p className={classes.heading}>Browse</p>
      <div className={classes.container_grid}>
        {menuItems.map((dataItem, idx) => {
          return (
            <button
              className={classes.grid_item}
              key={idx}
              onClick={() => handleNavigate(dataItem?.link)}
            >
              <img
                src={dataItem.img}
                alt={dataItem.name}
                className={classes.item_img}
              />
              <p className={classes.item}>{dataItem.name}</p>
            </button>
          );
        })}
      </div>

      <div className={classes.close_btn_container}>
        <button
          type="button"
          className={classes.close_btn}
          onClick={handleClose}
        >
          <i className={`pi pi-times ${classes.icon}`} />
        </button>
      </div>
    </motion.div>
  );
};

export default BrowseMenu;
